import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { NewchatComponent } from './components/newchat/newchat.component';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ChatbotInterceptorInterceptor } from '../services/interceptors/chatbot-interceptor/chatbot-interceptor.interceptor';
import { LoaderComponent } from './components/loader/loader.component';
import { SafeHtmlPipe, KeyHtmlPipe, SplitPipe } from '../pipes/safe-html/safe-html.pipe';
import { SourcePanelPipesModule } from './pipes/source-panel-pipes.module';
import { ConfigurationService } from '../services/configuration/configuration.service';
import { RtqMetadataComponent } from './metadata/rtq-metadata/rtq-metadata.component';
import { RacsMetadataComponent } from './metadata/racs-metadata/racs-metadata.component';
import { IycMetadataComponent } from './metadata/iyc-metadata/iyc-metadata.component';
import { ReplaceDoubleStarPipe } from '../pipes/replace-double-star/replace-double-star.pipe';
import { AutoResizeTextareaDirective } from '../directives/textarea/auto-resize-textarea.directive';
import { ChatSessionsComponent } from './components/chat-sessions/chat-sessions.component';
import { RegulationsMetadataComponent } from './metadata/regulations-metadata/regulations-metadata.component';
import { FeedbackSectionComponent } from './components/feedback-section/feedback-section.component';
import { IntroWizardComponent } from './components/intro-wizard/intro-wizard.component';
import { IntroSlidesComponent } from './components/intro-slides/intro-slides.component';
import { ChatbotOldComponent } from './components/chatbot-old/chatbot-old.component';
import { ChatbotWrapperComponent } from './components/chatbot-wrapper/chatbot-wrapper.component';
import { MetadataModule } from './metadata/metadata.module';
import { TotalMetadataItemsPipe } from '../pipes/total-metadata-items/total-metadata-items.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WelcomeTourComponent } from './components/welcome-tour/welcome-tour.component';
import { SourcePanelModule } from './components/source_panel/source-panel.module';
import { SharedChatViewerComponent } from './components/shared-chat-viewer/shared-chat-viewer.component';
import { AudioCopyComponent } from './components/audio-copy/audio-copy.component';
import { ShareConversationComponent } from './components/share-conversation/share-conversation.component';
import { TooltipModule } from './components/shared/tooltip/tooltip.module';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { versionedTranslateLoaderFactory } from '../services/i18n/versioned-translate.loader';
import { SanitizeMarkdownPipe } from '../pipes/sanitize-markdown.pipe/sanitize-markdown.pipe';
import { NewsUpdatesModule } from './components/news-updates/news-updates.module';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DevAuthService } from '../services/dev-service/dev-auth/dev-auth.service';
import { DevCookieService } from 'src/services/dev-service/dev-cookie/dev-cookie.service';
import { ApiService } from '../services/api/api.service';
import { AppInitializerService, initializeApp } from '../services/app-initializer/app-initializer.service';
// Feature Modules
import { AgentsModule } from './agents/agents.module';
import { SharedModule } from '../shared/shared.module';
import { MyFilesComponent } from './components/my-files/my-files.component';
import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';


@NgModule({
  declarations: [
    AppComponent,
    ChatbotComponent,
    NewchatComponent,
    LoaderComponent,
    SafeHtmlPipe,
    KeyHtmlPipe,
    SplitPipe,
    RtqMetadataComponent,
    RacsMetadataComponent,
    IycMetadataComponent,
    ReplaceDoubleStarPipe,
    AutoResizeTextareaDirective,
    ChatSessionsComponent,
    RegulationsMetadataComponent,
    FeedbackSectionComponent,
    IntroWizardComponent,
    IntroSlidesComponent,
    ChatbotOldComponent,
    ChatbotWrapperComponent,
    TotalMetadataItemsPipe,
    WelcomeTourComponent,
    SharedChatViewerComponent,
    AudioCopyComponent,
    SanitizeMarkdownPipe,
    ShareConversationComponent,
    FileUploadComponent,
    MyFilesComponent,
    FilePreviewComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    TooltipModule,
    PdfViewerModule,
    MarkdownModule.forRoot({
      loader: HttpClient,
      markedOptions: {
        provide: MarkedOptions,
        useValue: {
          gfm: true,
          tables: true,
          breaks: false,
          pedantic: false,
          smartLists: true,
          smartypants: false
        } as MarkedOptions
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: versionedTranslateLoaderFactory,
        deps: [HttpClient, ConfigurationService]
      }
    }),
    // Feature Modules
    MetadataModule,
    SharedModule,
    SourcePanelPipesModule,
    SourcePanelModule,
    NewsUpdatesModule,
    AgentsModule
  ],
  providers: [
    // Modern App Initializer
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitializerService],
      multi: true
    },
    // Services
    ApiService,
    AppInitializerService,
    DevAuthService,
    DevCookieService,
    ChatbotInterceptorInterceptor,
    { 
      provide: HTTP_INTERCEPTORS,
      useClass: ChatbotInterceptorInterceptor,
      multi: true 
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }